import { Accordion } from "@/components/ui/accordion";
import type { EntryResult, PlayerResult } from "@roman/shared/types/Result";
import { useState } from "react";
import { ShowOnlyMyTeam } from "../Schedule/ScheduleUsersTab";
import { PlayerRow } from "./PlayerRow";

export const PlayersTab = ({
  players,
  selectedEntry,
  roundEntryUnitId,
}: {
  players: PlayerResult[];
  selectedEntry: EntryResult;
  roundEntryUnitId: string;
}) => {
  const [showOnlyMyTeam, setShowOnlyMyTeam] = useState(false);
  const [expandedValues, setExpandedValues] = useState<string[]>([]);
  const isMyEntry = true;

  const isCaptain = (playerId: string): boolean => {
    return selectedEntry.selectedCaptains.captainPlayerId === playerId;
  };

  const isViceCaptain = (playerId: string): boolean => {
    if (selectedEntry.selectedCaptains.type === "0002") {
      return selectedEntry.selectedCaptains.viceCaptainPlayerId === playerId;
    }
    return false;
  };

  const filteredPlayers =
    !isMyEntry || showOnlyMyTeam
      ? players.filter((player) => selectedEntry.selectedPlayers.includes(player.id))
      : players;

  const sortedPlayers = filteredPlayers.sort((a, b) => b.fantasyPoint - a.fantasyPoint);

  return (
    <div className="py-2">
      <ShowOnlyMyTeam
        onClick={() => setShowOnlyMyTeam((prev) => !prev)}
        className={showOnlyMyTeam ? "bg-secondary" : "bg-disabled"}
      />

      <Accordion
        className="py-2"
        type="multiple"
        value={expandedValues}
        onValueChange={(value) => setExpandedValues(value)}
      >
        {sortedPlayers.map((player, index) => (
          <PlayerRow
            key={player.id}
            player={player}
            rank={index + 1}
            isInMyTeam={isMyEntry && selectedEntry.selectedPlayers.includes(player.id)}
            isCaptain={isCaptain(player.id)}
            isViceCaptain={isViceCaptain(player.id)}
            setExpandedValues={setExpandedValues}
            roundEntryUnitId={roundEntryUnitId}
            entryId={selectedEntry.id}
          />
        ))}
      </Accordion>
    </div>
  );
};
